// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"272":"MyAccount","449":"notFound","535":"login","578":"Plots","981":"propertiesCreate"}[chunkId] + "." + {"272":"9c33bca8","449":"6b0d27f2","535":"09ba8ce4","578":"fdb08a80","981":"09ba8ce4"}[chunkId] + ".chunk.css";
};